import React from 'react';
import PropTypes from 'prop-types';
import ProductTiles from './ProductTiles';


const EmptyCartRecommendations = function EmptyCartRecommendationsComponent({
  products, productLimit, title, ctaButton
}) {
  if (!(products && products.length > 0)) {
    return (
      <div className="empty-cart-recommendations__footer empty-cart-recommendations__footer--empty">
        <a href={ctaButton.url} className="empty-cart-recommendations__cta">{ctaButton.displayText}</a>
      </div>
    );
  }

  return (
    <div className="cart-recommendations">
      <div className="empty-cart-recommendations__body">
        <div className="empty-cart-recommendations__header">
          <div className="empty-cart-recommendations__title" role="heading" aria-level={2}>{title}</div>
        </div>
        <div className="cart-recommendations__wrapper cart-recommendations__wrapper--empty_cart">
          <ProductTiles productLimit={productLimit} products={products} emptyCart />
        </div>
        <div className="empty-cart-recommendations__footer">
          <a href={ctaButton.url} className="empty-cart-recommendations__cta">{ctaButton.displayText}</a>
        </div>
      </div>
    </div>
  );
};

EmptyCartRecommendations.propTypes = {
  title: PropTypes.string.isRequired,
  productLimit: PropTypes.number.isRequired,
  ctaButton: PropTypes.shape({}).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  continueShoppingRedirectUrl: PropTypes.string
};


export default EmptyCartRecommendations;
